window.addEventListener('load', () => {
    const tableHelpers = document.querySelectorAll('.table-helper');
    if (tableHelpers.length > 0) {
        tableHelpers.forEach(helper => {
            const button = helper.querySelector('button');
            const copyContainer = helper.querySelector('.copy-container');
            button.addEventListener('click', () => {
                copyContent(copyContainer);
            });
        });
    }
});

function copyContent(container) {
    const text = container.innerText.trim();

    navigator.clipboard.writeText(text)
        .then(() => {
            container.style.backgroundColor='#d7e9c3';
        })
        .catch(err => {
            console.error('Fehler beim Kopieren:', err);
        });
}
